/* Quitar el fondo 2.0 · Imprimirlo
 *
 * El mismo quitar-fondo del editor (tolerancia, «solo el fondo» o «todo ese color»
 * y la varita para añadir los colores que quieras quitar), pero para la ficha de
 * subida de diseños: pegatinas, imanes y transfers. Xavi, 01/10: «lo de quitar el
 * fondo pon el 2.0, el que se pueden elegir qué colores quitar».
 *
 *   QuitarFondo.abrir({ lienzo, alAplicar(canvas), alCancelar() })
 *
 * `lienzo` es la imagen ORIGINAL (canvas, a su tamaño). La previa trabaja a un
 * tamaño pequeño para que el deslizador vaya fino; al aplicar se repite el mismo
 * cálculo a tamaño completo, con los mismos ajustes y los mismos puntos de varita
 * (guardados en coordenadas relativas).
 *
 * Todo pasa en el navegador del cliente: no se sube nada.
 */
(function () {
  'use strict';

  var PREVIA = 560;           // px del lado mayor de la previa

  function nuevoLienzo(w, h) {
    var c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h));
    return c;
  }
  function escalar(c, lado) {
    var k = Math.min(1, lado / Math.max(c.width, c.height));
    var o = nuevoLienzo(c.width * k, c.height * k);
    var x = o.getContext('2d', { willReadFrequently: true });
    x.imageSmoothingQuality = 'high';
    x.drawImage(c, 0, 0, o.width, o.height);
    return o;
  }
  function copia(c) {
    var o = nuevoLienzo(c.width, c.height);
    o.getContext('2d', { willReadFrequently: true }).drawImage(c, 0, 0);
    return o;
  }

  // el lienzo con margen del color del borde, para que el relleno rodee el dibujo entero
  function conMargen(c, b) {
    var mg = Math.round(Math.max(c.width, c.height) * 0.12) + 4;
    var cm = nuevoLienzo(c.width + 2 * mg, c.height + 2 * mg);
    var cx = cm.getContext('2d');
    cx.fillStyle = b ? 'rgb(' + Math.round(b.r) + ',' + Math.round(b.g) + ',' + Math.round(b.b) + ')' : '#fff';
    cx.fillRect(0, 0, cm.width, cm.height); cx.drawImage(c, mg, mg);
    return cm;
  }
  function sinMargen(cm, w, h) {
    var mg = Math.round((cm.width - w) / 2);
    var c = nuevoLienzo(w, h);
    c.getContext('2d').drawImage(cm, -mg, -mg);
    return c;
  }

  // «todo ese color»: transparente lo que se parece, con borde suave entre t1 y t2
  function quitarColorGlobal(c, col, t1, t2) {
    var ctx = c.getContext('2d', { willReadFrequently: true }), d = ctx.getImageData(0, 0, c.width, c.height), p = d.data, n = 0;
    for (var i = 0; i < p.length; i += 4) {
      if (p[i + 3] < 8) continue;
      var dr = p[i] - col.r, dg = p[i + 1] - col.g, db = p[i + 2] - col.b, dd = Math.sqrt(dr * dr + dg * dg + db * db);
      if (dd <= t1) { p[i + 3] = 0; n++; }
      else if (dd < t2) p[i + 3] = Math.round(p[i + 3] * (dd - t1) / (t2 - t1));
    }
    ctx.putImageData(d, 0, 0);
    return { ok: n > 0, lienzo: c };
  }

  // «solo ese trozo»: relleno desde el punto tocado, con la misma tolerancia
  function quitarDesde(c, x0, y0, col, t1, t2) {
    var ctx = c.getContext('2d', { willReadFrequently: true }), d = ctx.getImageData(0, 0, c.width, c.height);
    var p = d.data, w = d.width, h = d.height, n = w * h;
    var visto = new Uint8Array(n), pila = new Int32Array(n), tope = 0, borrados = 0;
    function dist(i) { var dr = p[i * 4] - col.r, dg = p[i * 4 + 1] - col.g, db = p[i * 4 + 2] - col.b; return Math.sqrt(dr * dr + dg * dg + db * db); }
    function empuja(i) { if (visto[i] || p[i * 4 + 3] < 8 || dist(i) > t2) return; visto[i] = 1; pila[tope++] = i; }
    empuja(Math.max(0, Math.min(h - 1, y0)) * w + Math.max(0, Math.min(w - 1, x0)));
    while (tope > 0) {
      var i = pila[--tope], dd = dist(i), a = p[i * 4 + 3];
      if (dd <= t1) { p[i * 4 + 3] = 0; borrados++; }
      else { p[i * 4 + 3] = Math.round(a * Math.min(1, (dd - t1) / (t2 - t1))); continue; }
      var xi = i % w, yi = (i - xi) / w;
      if (xi > 0) empuja(i - 1);
      if (xi < w - 1) empuja(i + 1);
      if (yi > 0) empuja(i - w);
      if (yi < h - 1) empuja(i + w);
    }
    ctx.putImageData(d, 0, 0);
    return borrados;
  }

  /* El cálculo, el mismo en la previa y a tamaño completo.
     base: canvas sin tocar · e: { t (0-100), todo (bool), colores: [{r,g,b,nx,ny}] } */
  function calcular(base, e) {
    var t1 = 12 + e.t * 1.28, t2 = t1 + 60, res = null;
    try {
      var c = copia(base);
      var b = window.ImgArreglo && ImgArreglo.colorBorde ? ImgArreglo.colorBorde(c) : { r: 255, g: 255, b: 255 };
      if (e.todo) res = quitarColorGlobal(c, b, t1, t2);
      else if (window.ImgArreglo && ImgArreglo.quitarFondo) {
        var r1 = ImgArreglo.quitarFondo(conMargen(c, b), { t1: t1, t2: t2, minParte: 0.2 });
        res = (r1 && r1.ok) ? { ok: true, lienzo: sinMargen(r1.lienzo, c.width, c.height) } : { ok: false, motivo: r1 && r1.motivo };
      }
      if (e.colores.length) {
        var lz = (res && res.ok) ? res.lienzo : c, n = 0;
        e.colores.forEach(function (col) {
          if (e.todo) { if (quitarColorGlobal(lz, col, t1, t2).ok) n++; }
          else n += quitarDesde(lz, Math.round(col.nx * (lz.width - 1)), Math.round(col.ny * (lz.height - 1)), col, t1, t2);
        });
        if (n) res = { ok: true, lienzo: lz };
      }
    } catch (err) { res = { ok: false }; }
    return res || { ok: false };
  }

  function abrir(op) {
    var original = op.lienzo;
    var base = escalar(original, PREVIA);
    var e = { t: 39, todo: false, colores: [], varita: false };
    var ultimo = null, timer = null;

    var fondo = document.createElement('div');
    fondo.className = 'qf';
    fondo.setAttribute('role', 'dialog'); fondo.setAttribute('aria-modal', 'true'); fondo.setAttribute('aria-label', 'Quitar el fondo');
    fondo.innerHTML =
      '<div class="qf__caja">' +
        '<p class="qf__t">Quitar el fondo</p>' +
        '<div class="qf__lienzo"><canvas data-qf-lienzo></canvas></div>' +
        '<label class="qf__fila"><span>Tolerancia</span><input type="range" min="0" max="100" value="39" data-qf-tol aria-label="Tolerancia"><b data-qf-tolv>39</b></label>' +
        '<div class="qf__modo">' +
          '<label><input type="radio" name="qf-modo" value="contiguo" checked> Solo el fondo (lo que toca el borde)</label>' +
          '<label><input type="radio" name="qf-modo" value="todo"> Todo ese color, también por dentro</label>' +
        '</div>' +
        '<button type="button" class="qf__varita" data-qf-varita>🪄 Quitar otro color (tócalo)</button>' +
        '<div class="qf__chips" data-qf-chips hidden></div>' +
        '<p class="qf__nota" data-qf-nota></p>' +
        '<div class="qf__btns"><button type="button" class="qf__ok" data-qf-ok>Aplicar</button><button type="button" class="qf__no" data-qf-no>Cancelar</button></div>' +
      '</div>';
    document.body.appendChild(fondo);
    document.documentElement.classList.add('qf-abierto');

    var lienzo = fondo.querySelector('[data-qf-lienzo]'), nota = fondo.querySelector('[data-qf-nota]');
    var rango = fondo.querySelector('[data-qf-tol]'), rangoV = fondo.querySelector('[data-qf-tolv]');
    var btnVarita = fondo.querySelector('[data-qf-varita]'), chips = fondo.querySelector('[data-qf-chips]');
    var btnOk = fondo.querySelector('[data-qf-ok]');
    lienzo.width = base.width; lienzo.height = base.height;

    function llena() { rango.style.setProperty('--sdtf-llena', rango.value + '%'); }
    function pintarChips() {
      chips.hidden = !e.colores.length;
      chips.innerHTML = e.colores.map(function (c, i) {
        return '<span class="qf__chip"><i style="background:rgb(' + c.r + ',' + c.g + ',' + c.b + ')"></i>' +
          '<button type="button" data-chip="' + i + '" aria-label="Dejar de quitar este color">×</button></span>';
      }).join('');
    }
    function pintar(res) {
      var x = lienzo.getContext('2d');
      x.clearRect(0, 0, lienzo.width, lienzo.height);
      x.drawImage(res && res.ok ? res.lienzo : base, 0, 0);
    }
    function previsualizar() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var res = calcular(base, e);
        ultimo = res.ok ? res : null;
        pintar(res);
        btnOk.disabled = !res.ok;
        nota.textContent = res.ok ? '' : (res.motivo === 'mezclado'
          ? 'Con esta tolerancia se agujerea el dibujo: prueba con menos, o con «todo ese color».'
          : 'No vemos un fondo liso que quitar. Prueba con «todo ese color», o toca con la varita el color que quieras quitar.');
      }, 90);
    }
    function cerrar() {
      clearTimeout(timer);
      document.removeEventListener('keydown', teclas, true);
      document.documentElement.classList.remove('qf-abierto');
      if (fondo.parentNode) fondo.parentNode.removeChild(fondo);
    }
    function teclas(ev) { if (ev.key === 'Escape') { ev.stopPropagation(); cerrar(); if (op.alCancelar) op.alCancelar(); } }
    document.addEventListener('keydown', teclas, true);

    rango.addEventListener('input', function () { rangoV.textContent = rango.value; e.t = parseInt(rango.value, 10) || 0; llena(); previsualizar(); });
    Array.prototype.forEach.call(fondo.querySelectorAll('input[name="qf-modo"]'), function (r) {
      r.addEventListener('change', function () { e.todo = r.value === 'todo' && r.checked; previsualizar(); });
    });
    function varitaActiva(si) {
      e.varita = !!si;
      fondo.classList.toggle('is-varita', e.varita);
      btnVarita.classList.toggle('is-on', e.varita);
      btnVarita.textContent = e.varita ? '🪄 Toca en el diseño el color a quitar' : '🪄 Quitar otro color (tócalo)';
    }
    btnVarita.addEventListener('click', function () { varitaActiva(!e.varita); });
    // la varita: el color sale de la imagen SIN tocar, en el punto donde se toca
    lienzo.addEventListener('click', function (ev) {
      if (!e.varita) return;
      var r = lienzo.getBoundingClientRect();
      var nx = (ev.clientX - r.left) / r.width, ny = (ev.clientY - r.top) / r.height;
      if (nx < 0 || nx > 1 || ny < 0 || ny > 1) return;
      var px = base.getContext('2d', { willReadFrequently: true }).getImageData(Math.min(base.width - 1, Math.round(nx * (base.width - 1))), Math.min(base.height - 1, Math.round(ny * (base.height - 1))), 1, 1).data;
      if (px[3] < 8) { nota.textContent = 'Ahí ya no hay nada que quitar.'; return; }
      e.colores.push({ r: px[0], g: px[1], b: px[2], nx: nx, ny: ny });
      pintarChips(); varitaActiva(false); previsualizar();
    });
    chips.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-chip]');
      if (!b) return;
      e.colores.splice(parseInt(b.getAttribute('data-chip'), 10), 1);
      pintarChips(); previsualizar();
    });
    fondo.addEventListener('click', function (ev) { if (ev.target === fondo) { cerrar(); if (op.alCancelar) op.alCancelar(); } });
    fondo.querySelector('[data-qf-no]').addEventListener('click', function () { cerrar(); if (op.alCancelar) op.alCancelar(); });
    btnOk.addEventListener('click', function () {
      if (!ultimo) return;
      btnOk.disabled = true; btnOk.textContent = 'Aplicando…';
      // a tamaño completo, con los mismos ajustes
      setTimeout(function () {
        var fin = calcular(original, e);
        cerrar();
        if (fin.ok && op.alAplicar) op.alAplicar(fin.lienzo);
        else if (op.alCancelar) op.alCancelar();
      }, 40);
    });

    llena(); pintarChips(); previsualizar();
    setTimeout(function () { try { btnOk.focus({ preventScroll: true }); } catch (x) {} }, 50);
  }

  window.QuitarFondo = { abrir: abrir };
})();
